export const MyList = ({ children, ...props }: any) => <div {...props}>{children}</div>;
